export default class CertificateHistoryService {
  constructor(http) {
    this.http = http;
  }

  async findAllCertificateHistoryWithRegiInfoBySchoolid(
    certificateHistory = {}
  ) {
    const queryParams = Object.entries(certificateHistory)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(
      `/api/certificatehistory/readallWithUsers?${queryParams}`,
      {
        method: "GET",
      }
    );
  }

  async updateCertificateHistory(certificateHistory) {
    return this.http.fetch(`/api/certificatehistory/update`, {
      method: "PUT",
      body: JSON.stringify(certificateHistory),
    });
  }

  async createCertificateHistory(certificateHistory) {
    return this.http.fetch(`/api/certificatehistory/create`, {
      method: "POST",
      body: JSON.stringify(certificateHistory),
    });
  }

  async deleteCertificateHistory(id) {
    return this.http.fetch(`/api/certificatehistory/delete`, {
      method: "DELETE",
      body: JSON.stringify({ id }),
    });
  }
}
